// src/pages/LandingPage/Testimonials.jsx
import {
    Box,
    Container,
    Heading,
    Text,
    Stack,
    Avatar,
    Flex,
    SimpleGrid,
    useColorModeValue
  } from '@chakra-ui/react';
  
  const TestimonialCard = ({ content, avatar, name, location }) => {
    return (
      <Box
        bg={useColorModeValue('white', 'gray.800')}
        borderRadius="lg"
        p={8}
        boxShadow="md"
        position="relative"
      >
        <Text
          fontSize="6xl"
          position="absolute"
          top="10px"
          left="20px"
          color="brand.primary"
          opacity={0.2}
          lineHeight={1}
        >
          "
        </Text>
        <Text
          color={useColorModeValue('gray.600', 'gray.400')}
          fontSize="md"
          mb={6}
          fontStyle="italic"
          position="relative"
          zIndex={1}
        >
          {content}
        </Text>
        <Flex align="center">
          <Avatar src={avatar} alt={name} mr={4} />
          <Stack spacing={0}>
            <Text fontWeight={600} color="brand.primary">
              {name}
            </Text>
            <Text fontSize="sm" color={useColorModeValue('gray.500', 'gray.400')}>
              {location}
            </Text>
          </Stack>
        </Flex>
      </Box>
    );
  };
  
  const Testimonials = () => {
    return (
      <Box bg={useColorModeValue('gray.50', 'gray.900')} py={20}>
        <Container maxW={'1200px'}>
          <Heading
            as="h2"
            fontSize={{ base: '3xl', md: '4xl' }}
            textAlign={'center'}
            mb={16}
            color="brand.primary"
          >
            O que nossos clientes dizem
          </Heading>
  
          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={10}>
            <TestimonialCard
              content="Colorir nossa foto de casamento trouxe de volta a emoção daquele dia. Foi uma experiência terapêutica que me conectou ainda mais com aquele momento especial."
              avatar="/img/avatar1.png"             
              name="Juliana Ribeiro"
              location="Rio de Janeiro"
            />
            <TestimonialCard
              content="Presenteei minha mãe com um livro de desenhos das nossas fotos de família. Ela ficou emocionada e agora temos uma atividade relaxante para fazer juntas."
              avatar="/img/avatar2.png"
              name="Karla Pereira"
              location="São Paulo"
            />
            <TestimonialCard
              content="Transformei fotos da nossa viagem à Europa em desenhos para colorir. É uma forma incrível de reviver as memórias e ainda relaxar depois de um dia estressante."
              avatar="/img/avatar3.png"
              name="Amanda Costa"
              location="Belo Horizonte"
            />
          </SimpleGrid>
        </Container>
      </Box>
    );
  };
  
  export default Testimonials;